import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-metric-min",
  "use": "icon-metric-min-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-metric-min\"><path d=\"m10.6 8.1-2.1 2.2V4h-1v6.3L5.4 8.1l-.8.8L8 12.2l3.4-3.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol